import { IUserTokenData } from '../models/user.model';

export function getUserTokenData() {
    if (typeof window === 'undefined') return null;
    const tokenData = localStorage.getItem('tokenData');
    return tokenData ? (JSON.parse(tokenData) as IUserTokenData) : null;
}
